export default __webpack_public_path__ + "static/media/35fbd08e850612f87a94bef45573ba1a1629923709382.addb94f7.webp";